export default __webpack_public_path__ + "static/media/success.02c07525.svg";